import React from "react";

import PenStepOne from "img/how-to-img/pen.png";
import CorrectStepTwo from "img/how-to-img/correct.png";
import PackageBoyStepThree from "img/how-to-img/package-boy.png";
import DeliveryTruckStepFour from "img/how-to-img/delivery-truck.png";
import CorrectStepFive from "img/how-to-img/product-correct.png";


export default function HowToTraveller() {
  return (
    <div className="step-list">
    <h1 className="small-heading">Steps to Delivery Process</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PenStepOne}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Delivery Request Submitted
          </h1>
          <p className="small-para">
            The Customer initiates a new delivery by entering package details,
            pickup and dropoff locations, and contact information. The request
            is logged and prepared for scheduling.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={CorrectStepTwo}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Pickup Scheduled & Confirmed
          </h1>
          <p className="small-para">
            A courier is assigned and the pickup time is confirmed. The customer
            is notified with delivery tracking details, and the courier is
            dispatched accordingly.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PackageBoyStepThree}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Package Collected
          </h1>
          <p className="small-para">
            At pickup, the courier scans a QR code provided by the sender to
            verify and confirm that the correct package is being handed over.
            This begins the official tracking and custody process.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={DeliveryTruckStepFour}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: In Transit with Live Tracking
          </h1>
          <p className="small-para">
            The package is transported through the delivery network. Customers
            can view real-time updates via the tracking dashboard and receive
            key status notifications during transit.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={CorrectStepFive}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Secure Delivery Completed
          </h1>
          <p className="small-para">
            Upon reaching the destination, the courier scans a QR code presented
            by the recipient to confirm handover. The delivery is marked
            complete, and a digital proof of delivery is generated.
          </p>
        </div>
      </div>
    </div>
  );
}
